import React, { Component } from "react";
import { Grid, Container, Box, Typography, useMediaQuery } from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import Link from "@mui/material/Link";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Images from "../../components/theme-constants/image";
import logo from "../../logo.svg";
import "./footer.css";


function Footer() {
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down("sm"));


  return (
      <Box>
        <Box className="footer-top">
          <Container maxWidth="xl" className="container">
            <Grid
              container
              spacing={5}
              justifyContent="space-between"
              alignItems="end"
            >
              <Grid item xs={3} className="display-none">
                <Box className="footer-logo">
                  <Link href="/">
                    <img
                      src={logo}
                      className="App-logo"
                      alt="F9 Info Technologies"
                    />
                  </Link>
                </Box>
              </Grid>
              <Grid item className="footer-socail">
                <List>
                  <ListItem>
                    <Link href="https://www.linkedin.com/company/f9-info-technologies" target="_blank" rel="noopener noreferrer">
                      <CardMedia
                        component="img"
                        image={Images.Linkedin.default}
                        alt="LinkedIn"
                      />
                    </Link>
                  </ListItem>

                  <ListItem>
                    <Link href="https://www.facebook.com/f9tech" target="_blank" rel="noopener noreferrer">
                      <CardMedia
                        component="img"
                        image={Images.Facebook.default}
                        alt="Facebook"
                      />
                    </Link>
                  </ListItem>
                  <ListItem>
                    <Link href="https://www.instagram.com/f9tech" target="_blank" rel="noopener noreferrer">
                      <CardMedia
                        component="img"
                        image={Images.Instragram.default}
                        alt="Instagram"
                      />
                    </Link>
                  </ListItem>
                  <ListItem>
                    <Link href="https://github.com/F9info" target="_blank" rel="noopener noreferrer">
                      <CardMedia
                        component="img"
                        image={Images.GitHub.default}
                        alt="GitHub"
                      />
                    </Link>
                  </ListItem>
                  <ListItem>
                    <Link href="https://www.youtube.com/@f9tech/videos" target="_blank" rel="noopener noreferrer">
                      <CardMedia
                        component="img"
                        image={Images.YouTube.default}
                        alt="YouTube"
                      />
                    </Link>
                  </ListItem>
                </List>
              </Grid>
              <Grid item xs={2} className="display-none">
                &nbsp;
              </Grid>
            </Grid>
          </Container>
        </Box>
        <Box className="bg-secondary footer-middle" sx={{ py: 13 }}>
          <Container maxWidth="xl" className="container">
            {" "}
            <Container maxWidth="xl" className="container">
              <Grid
                container
                spacing={5}
                justifyContent="center"
                alignItems="start"
              >
                <Grid item xs={isSmallScreen ? 12 : 3} className="block">
                  <Box className="footer-nav">
                    <Typography className="footer-title">SERVICES</Typography>
                    <List>
                      <ListItem>
                        <Link href="/services">MOBILE APP DEVELOPMENT</Link>
                      </ListItem>
                      <ListItem>
                        <Link href="/services">WEB APP DEVELOPMENT</Link>
                      </ListItem>
                      <ListItem>
                        <Link href="/services">DIGITAL MARKETING</Link>
                      </ListItem>
                      <ListItem>
                        <Link href="/services">GRAPHIC DESIGNING</Link>
                      </ListItem>
                      <ListItem>
                        <Link href="/services">UI/UX DESIGN</Link>
                      </ListItem>
                      <ListItem>
                        <Link href="/solutions">BUSINESS SOLUTIONS</Link>
                      </ListItem>
                    </List>
                  </Box>
                </Grid>
                <Grid item xs={isSmallScreen ? 12 : 3}  className="block">
                  <Box className="footer-nav">
                    <Typography className="footer-title">SOLUTIONS</Typography>
                    <List>
                      <ListItem>
                        <Link href="/solutions">F9 CRM</Link>
                      </ListItem>
                      <ListItem>
                        <Link href="/solutions">ASSOCIATION MANAGEMENT</Link>
                      </ListItem>
                     
                    </List>
                  </Box>
                </Grid>
                <Grid item xs={isSmallScreen ? 12 : 3}  className="block">
                  <Box className="footer-nav">
                    <Typography className="footer-title">
                      QUICK LINKS
                    </Typography>
                    <List>
                      <ListItem>
                        <Link href="https://github.com/F9info" target="_blank" rel="noopener noreferrer">OPEN SOURCE</Link>
                      </ListItem>
                       <ListItem>
                        <Link href="/solutions">FLUTTER CMS</Link>
                      </ListItem>
                      <ListItem>
                        <Link href="/solutions">PR CMS</Link>
                      </ListItem>
                    </List>
                  </Box>
                </Grid>
                <Grid item xs={isSmallScreen ? 12 : 3}  className="block">
                  <Box className="footer-nav">
                    <Typography className="footer-phone">
                      <Link href="tel:+918919693567">+91 891 969 3567</Link>
                    </Typography>
                    <Typography className="footer-email">
                      <Link href="mailto:projects@f9tech.com">projects@f9tech.com</Link>
                    </Typography>
                    <Typography className="footer-address">
                      Vinayagar Heights, Sampath Vinayaka TempleRoad
                      <br />
                      Waltair Uplands, Opp. Kalyan Jewellers
                      <br />
                      Visakhapatnam – 530003, <br />
                      Andhra Pradesh (INDIA)
                      <br />
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
              <Grid className="footer-bottom"
                container
                spacing={5}
                justifyContent="space-between"
                alignItems="end"
              >
                <Grid item xs={isSmallScreen ? 12 : 4} >
                <List>
                  <ListItem>
                    <Link href="https://kalamdreamlabs.com/" target="_blank" rel="noopener noreferrer">
                      <CardMedia
                        component="img"
                        image={Images.KDL.default}
                        alt="Kalam Dream Labs"
                      />
                    </Link>
                  </ListItem>
                  <ListItem>
                    <Link href="https://bni-visakhapatnam.in/en-IN/index" target="_blank" rel="noopener noreferrer">
                      <CardMedia
                        component="img"
                        image={Images.BNI.default}
                        alt="BNI Visakhapatnam"
                      />
                    </Link>
                  </ListItem>
                  <ListItem>
                    <Link href="https://partnershipsummit.com/" target="_blank" rel="noopener noreferrer">
                      <CardMedia
                        component="img"
                        image={Images.CII.default}
                        alt="CII"
                      />
                    </Link>
                  </ListItem>
                  <ListItem>
                    <Link href="https://vizagstartups.in/" target="_blank" rel="noopener noreferrer">
                      <CardMedia
                        component="img"
                        image={Images.VS.default}
                        alt="Vizag Startups"
                      />
                    </Link>
                  </ListItem>
                </List>
                </Grid>
                <Grid item className="footer-content">
                  <Typography>
                    ©2024 F9 Info Technologies Private Limited. All Rights
                    Reserved
                  </Typography>
                  <List>
                    <ListItem>
                      <Link href="/terms">TERMS & CONDITIONS</Link>
                    </ListItem>
                    <ListItem>
                      <Link href="/privacy">PRIVACY POLICY</Link>
                    </ListItem>
                    <ListItem>
                      <Link href="/sitemap">SITEMAP</Link>
                    </ListItem>
                    <ListItem>
                      <Link href="https://medium.com/@f9tech" target="_blank" rel="noopener noreferrer">BLOGS</Link>
                    </ListItem>
                  </List>
                </Grid>
                <Grid item xs={isSmallScreen ? 12 : 3} >
                <List>
                  <ListItem>
                    <Link href="https://www.dmca.com/" target="_blank" rel="noopener noreferrer">
                      <CardMedia
                        component="img"
                        image={Images.DRMCA.default}
                        alt="DMCA Protected"
                      />
                    </Link>
                  </ListItem>
                  <ListItem>
                    <Link href="https://www.copyscape.com/" target="_blank" rel="noopener noreferrer">
                      <CardMedia
                        component="img"
                        image={Images.Pro.default}
                        alt="Protected by Copyscape"
                      />
                    </Link>
                  </ListItem>
                  </List>
                </Grid>
              </Grid>
            </Container>
          </Container>
        </Box>
      </Box>
  );
}

export default Footer;
